"use client"
import React from 'react';
import Image from 'next/image';
import { FiUser, FiCalendar } from 'react-icons/fi';
import SocialShareButtons from './SocialShareButtons';
import ReadingTime from './ReadingTime';
import TableOfContents from './TableOfContents';

const BlogLayout = ({
  title,
  description,
  author,
  date,
  imageSrc,
  imageAlt,
  content,
  estimatedReadingTime,
  relatedPosts
}) => {

  return (
    <div className="bg-gray-50 min-h-screen pb-16">
      {/* Hero Banner */}
      <div className="relative w-full h-[50vh] min-h-[400px]">
        <div className="absolute inset-0">
          <Image
            src={imageSrc}
            fill
            priority
            style={{ objectFit: "cover" }}
            alt={imageAlt || "Blog post featured image"}
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/60 to-black/30" />
        </div>
        
        <div className="relative container mx-auto px-4 h-full flex flex-col justify-end pb-10">
          <div className="max-w-3xl">
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4 text-white">
              {title}
            </h1>
            <div className="flex flex-wrap items-center text-gray-200 mb-4 gap-4">
              <div className="flex items-center">
                <FiUser className="mr-2" />
                <span>By {author}</span>
              </div>
              <div className="flex items-center">
                <FiCalendar className="mr-2" />
                <span>{date}</span>
              </div>
              {estimatedReadingTime && (
                <ReadingTime text={estimatedReadingTime} />
              )}
            </div>
          </div>
        </div>
      </div>
      
      <div className="container mx-auto px-4 py-8">
        <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-md overflow-hidden">
          {/* Blog Content */}
          <div className="p-6 md:p-10">
            <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
              {/* Sidebar for larger screens */}
              <div className="hidden md:block md:col-span-3 relative">
                <div className="md:sticky md:top-24">
                  <TableOfContents />
                  <SocialShareButtons title={title} />
                </div>
              </div>
              
              {/* Main Content */}
              <div className="md:col-span-9">
                <div className="prose prose-lg max-w-none">
                  {content}
                </div>
                
                {/* Social Share for mobile */}
                <div className="md:hidden mt-8">
                  <SocialShareButtons title={title} />
                </div>
              </div>
            </div>
          </div>
          
          {/* Related Posts */}
          {relatedPosts && relatedPosts.length > 0 && (
            <div className="border-t border-gray-100 p-6 md:p-10 bg-gray-50">
              <h3 className="text-xl font-bold text-gray-800 mb-6">Related Posts</h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {relatedPosts}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default BlogLayout; 